

import store from './store/index';
import router from './router/router';
import App from './App.vue';
import CreateApp from '../../global/app';

const parentAppId = '#app';
const vm = CreateApp({ App, store, router });
vm.$mount(parentAppId);
